(function() {
  const box = document.getElementById('pipoca-delivery-estimate');
  const textEl = document.getElementById('pipoca-delivery-estimate-text');
  if (!box || !textEl) return;

  const locale = box.dataset.locale || 'es';

  // Mismo mapa de tránsito que el pack selector (días laborables mín-máx)
  const transitMap = {
    ES: [1, 2], PT: [1, 2],
    FR: [2, 7], DE: [2, 7], IT: [2, 7],
    CH: [3, 7], GB: [3, 7], NO: [3, 7]
  };
  const defaultTransit = [3, 7];

  function getTransitRange() {
    const country = (window.Shopify && Shopify.country) || 'ES';
    return transitMap[country] || defaultTransit;
  }

  const CUTOFF_HOUR = 15;
  const CUTOFF_TIMEZONE = 'Europe/Lisbon';

  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6; // domingo o sábado
  }

  function addBusinessDays(date, daysToAdd) {
    const result = new Date(date);
    let added = 0;
    while (added < daysToAdd) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) added++;
    }
    return result;
  }

  // Devuelve la hora actual "tal cual se vería" en Europe/Lisbon,
  // independientemente de la zona horaria del dispositivo del visitante.
  function getNowInLisbon() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: CUTOFF_TIMEZONE,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    const get = (type) => parts.find(p => p.type === type).value;
    // new Date(year, monthIndex, day, hour, minute, second) usando los componentes de Lisboa
    return new Date(
      parseInt(get('year')),
      parseInt(get('month')) - 1,
      parseInt(get('day')),
      parseInt(get('hour')),
      parseInt(get('minute')),
      parseInt(get('second'))
    );
  }

  function getShipDate() {
    const nowLisbon = getNowInLisbon();
    const afterCutoff = nowLisbon.getHours() >= CUTOFF_HOUR;
    let shipDate = new Date(nowLisbon);
    shipDate.setHours(0, 0, 0, 0);

    if (afterCutoff) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // Si el día de salida cae en fin de semana, mover al siguiente día laborable
    while (isWeekend(shipDate)) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    return shipDate;
  }

  const monthNames = {
    es: ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    fr: ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'],
    de: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    it: ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre']
  };

  const dayNames = {
    es: ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
    en: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    fr: ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],
    de: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    it: ['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato']
  };

function formatShortDate(date, locale, includeMonth) {
    const dn = (dayNames[locale] || dayNames.es)[date.getDay()];
    const mn = (monthNames[locale] || monthNames.es)[date.getMonth()];
    const d = date.getDate();

    if (!includeMonth) {
      // Solo día de la semana + número, sin mes (se añade aparte al final de la frase)
      if (locale === 'en') return `${dn} ${d}`;
      if (locale === 'de') return `${dn}, ${d}.`;
      return `${dn} ${d}`; // es / fr / it
    }

    if (locale === 'en') return `${dn} ${mn} ${d}`;
    if (locale === 'de') return `${dn}, ${d}. ${mn}`;
    if (locale === 'fr' || locale === 'it') return `${dn} ${d} ${mn}`;
    return `${dn} ${d} de ${mn}`; // es
  }

function render() {
    const today = getNowInLisbon();
    today.setHours(0, 0, 0, 0);

    const shipDate = getShipDate();
    const [minDays, maxDays] = getTransitRange();

    const minDate = addBusinessDays(shipDate, minDays);
    const maxDate = addBusinessDays(shipDate, maxDays);

    const sameMonth = minDate.getMonth() === maxDate.getMonth();

    // Si coinciden de mes, el mes solo se muestra una vez (en la segunda fecha)
    const minLabel = formatShortDate(minDate, locale, !sameMonth);
    const maxLabel = formatShortDate(maxDate, locale, true);

    const templates = {
      es: (a, b) => `Pídelo ahora y recíbelo entre el <strong>${a}</strong> y el <strong>${b}</strong>`,
      en: (a, b) => `Order now, get it between <strong>${a}</strong> and <strong>${b}</strong>`,
      fr: (a, b) => `Commandez maintenant, livraison entre le <strong>${a}</strong> et le <strong>${b}</strong>`,
      de: (a, b) => `Jetzt bestellen, Lieferung zwischen <strong>${a}</strong> und <strong>${b}</strong>`,
      it: (a, b) => `Ordina ora e ricevilo tra <strong>${a}</strong> e <strong>${b}</strong>`
    };
    const template = templates[locale] || templates.es;

    textEl.innerHTML = template(minLabel, maxLabel);
  }

  render();
})();